import type { CityCode } from '@loci/city-editions';

/**
 * Single source of truth for the default values backing the
 * `NEXT_PUBLIC_DEFAULT_CITY_CODE` and `NEXT_PUBLIC_APEX_BEHAVIOR` env vars
 * (APO-201). Both the Zod schema in `apps/web/config/env.ts` and the edge-
 * runtime fallback in `apps/web/proxy.ts` import these constants so the
 * schema default and the runtime default cannot drift.
 *
 * No imports beyond pure types — this module is safe to load from the edge
 * runtime without dragging in the full `serverEnv` validation chain.
 */

export const DEFAULT_CITY_CODE_FALLBACK = 'CLT' satisfies CityCode;

export const APEX_BEHAVIORS = ['picker', 'redirect-default'] as const;
export type ApexBehavior = (typeof APEX_BEHAVIORS)[number];

export const DEFAULT_APEX_BEHAVIOR: ApexBehavior = 'redirect-default';
